import auth from 'src/router/middleware/authentification/auth.js'
import registration from 'src/router/middleware/authentification/registration.js'

const Settings = () => import('src/views/User/Settings/SettingsIndex.vue')
const Profile = () => import('src/views/User/Settings/Profile/SettingsProfile.vue')
const SettingsFamily = () => import('src/views/User/Settings/SettingsFamily.vue')
const ChildWrapper = () => import('src/views/User/Settings/Family/ChildWrapper.vue')
const ChildName = () => import('src/views/User/Settings/Family/ChildName.vue')
const ChildGrade = () => import('src/views/User/Settings/Family/ChildGrade.vue')
const ChildRelation = () => import('src/views/User/Settings/Family/ChildRelation.vue')
const ChildActivationkey = () => import('src/views/User/Settings/Family/ChildActivationkey.vue')
const SettingsRegisterGender = () => import('src/views/User/Settings/SettingsRegisterGender.vue')
const SettingsAddParent = () => import('src/views/User/Settings/Profile/SettingsAddParent.vue')
const SettingsHintVideos = () => import('src/views/User/Settings/SettingsHintVideos.vue')
const SettingsMultiAccounts = () => import('src/views/User/Settings/SettingsMultiAccounts.vue')
const SettingsMuteNotifications = () => import('src/views/User/Settings/SettingsMuteNotifications.vue')
const SettingsHelpNotifications = () => import('src/views/User/Settings/SettingsHelpNotifications.vue')
const SettingsDeleteAccount = () => import('src/views/User/Settings/Profile/SettingsDeleteAccount.vue')
const SettingsNotificationGeneral = () => import('src/views/User/Settings/SettingsNotificationGeneral.vue')
const SettingsCopyright = () => import('src/views/User/Settings/SettingsCopyright.vue')
const SettingsReleaseNotes = () => import('src/views/User/Settings/SettingsReleaseNotes.vue')
const SettingsSecurity = () => import('src/views/User/Settings/SettingsSecurity.vue')

export default [
  {
    path: '/settings',
    component: Settings,
    name: 'settings-overview-01',
    meta: {
      layout: 'sdui',
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.settings',
      iconSettings: 'icon-settings',
      enableSwReload: true
    }
  },
  {
    path: '/settings/fill-user-details',
    component: SettingsRegisterGender,
    name: 'fill-user-details',
    meta: {
      middleware: [auth],
      headerText: 'global.headers.settings'
    }
  },
  {
    path: '/settings/videos',
    component: SettingsHintVideos,
    name: 'settings-videos',
    meta: {
      middleware: [auth],
      headerText: 'global.headers.videos'
    }
  },
  {
    path: '/settings/:id',
    component: Profile,
    name: 'settings-user',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.settings'
    }
  },
  {
    path: '/settings/:id/delete-account',
    component: SettingsDeleteAccount,
    name: 'settings-delete-account',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.settings'
    }
  },
  {
    path: '/settings/:id/family',
    component: SettingsFamily,
    name: 'settings-family',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.settings'
    }
  },
  {
    path: '/users-select',
    component: SettingsMultiAccounts,
    name: 'settings-multi-users',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.accounts'
    }
  },
  {
    path: '/settings/:id/add-parent',
    component: SettingsAddParent,
    name: 'settings-add-parent',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.add_parent'
    }
  },
  {
    path: '/settings/copyright/:id',
    component: SettingsCopyright,
    name: 'settings-copyright',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.copyright'
    }
  },
  {
    path: '/release-notes',
    component: SettingsReleaseNotes,
    name: 'release-notes',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.release_notes'
    }
  },
  {
    path: '/settings/security/:id',
    component: SettingsSecurity,
    name: 'settings-security',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.security'
    }
  },
  {
    path: '/settings/:id/notifications/preview',
    component: SettingsNotificationGeneral,
    name: 'settings-notifications-general',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.settings'
    }
  },
  {
    path: '/settings/:id/notifications/mute',
    component: SettingsMuteNotifications,
    name: 'settings-mute-notifications',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.silent_times'
    }
  },
  {
    path: '/settings/:id/notifications/help-push',
    component: SettingsHelpNotifications,
    name: 'help-push-notifications',
    meta: {
      middleware: [auth],
      group: 'account',
      headerText: 'global.headers.push_notifications'
    }
  },
  {
    path: '/settings/add-child',
    component: ChildWrapper,
    children: [
      {
        path: 'activation-key',
        component: ChildActivationkey,
        name: 'add-child-activation-key',
        meta: {
          middleware: [auth],
          progress: 1,
          headerText: 'global.headers.add_child'
        }
      },
      {
        path: 'name',
        component: ChildName,
        name: 'add-child-name',
        meta: {
          middleware: [auth, registration],
          progress: 2,
          headerText: 'global.headers.add_child'
        }
      },
      {
        path: 'grade',
        component: ChildGrade,
        name: 'add-child-grade',
        meta: {
          middleware: [auth, registration],
          progress: 3,
          headerText: 'global.headers.add_child'
        }
      },
      {
        path: 'relationship',
        component: ChildRelation,
        name: 'add-child-relation',
        meta: {
          middleware: [auth, registration],
          progress: 4,
          headerText: 'global.headers.add_child'
        }
      }
    ]
  }
]
